import { ScreenManager, ScreenManagerEvents } from "../../managers/ScreenManager";
import { CardData, TrickData } from "../../types/types";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { LoaderFileKeys } from "../constant/AppConstants";
import { AppLocalization, LanguageId } from "../localization/AppLocalization";
import { CardsManager } from "../managers/CardsManager";
import { TableToggleComponentView, ToggleState } from "./TableToggleComponentView";




/**
Execution order:
Init()
Build()
PostBuild();
--
SetData()?
Reset()?
 */
export class LastTrickView extends TableToggleComponentView {
    // asset instances
    public imgCards: Phaser.GameObjects.Image[];
    public grCardStroke: Phaser.GameObjects.Graphics;

    /**
     * - indexes: 0=top card, 1=right card, 2=bottom card, 3=left card
     */
    private cardTrickData: TrickData;


    public override Build(): void {
        // build:
        // - bg
        // - label
        // - arrow
        // - content (empty container)
        super.Build();

        this.imgArrow.scaleX = -1;

        // card images
        const posOffset: any = { x: 135, y: 90 };
        this.imgCards = [];
        const imgPositions: any[] = [
            { x: 0, y: -posOffset.y },
            { x: posOffset.x, y: 0 },
            { x: 0, y: posOffset.y },
            { x: -posOffset.x, y: 0 },
        ];
        for (let i: number = 0; i < 4; i++) {
            const img = this.scene.make.image({ key: LoaderFileKeys.cardsDeck, frame: "" });
            img.setScale(1.4);
            img.setPosition(imgPositions[i].x, imgPositions[i].y);
            this.imgCards.push(img);
            // this.conContent.add(img);
        }

        // 'selected card stroke'
        this.grCardStroke = this.scene.make.graphics({
            x: 0,
            y: 0,
            // lineStyle: { color: 0x000000, alpha: 0.9 },
            fillStyle: { color: 0xff0000, alpha: 1.0 },
        });
        const strokeThickness: number = 10;
        const anyCardImg: Phaser.GameObjects.Image = this.imgCards[0];
        this.grCardStroke.fillStyle(this.grCardStroke.defaultFillColor, this.grCardStroke.defaultFillAlpha);
        this.grCardStroke.fillRoundedRect(-anyCardImg.displayWidth / 2 - strokeThickness, -anyCardImg.displayHeight / 2 - strokeThickness, anyCardImg.displayWidth + strokeThickness * 2, anyCardImg.displayHeight + strokeThickness * 2, 40);
        this.grCardStroke.scale = 0.35;
        this.conContent.add(this.grCardStroke);

        // add cards after stroke
        this.imgCards.forEach(img => {
            this.conContent.add(img);
        })

        // this.UpdateViewFromLocalizationChange();

        // DEBUG
        // this.SetSelectedCardIndex(3);
    }

    public SetSelectedCardIndex(cardIndex: number): void {
        const cardImg: Phaser.GameObjects.Image = this.imgCards[cardIndex];
        this.grCardStroke.setPosition(cardImg.x, cardImg.y);
    }

    /**
     * Will refresh view
     * @param trickData 
     */
    public override SetData(trickData: TrickData = undefined): void {
        // console.log(" LastTrickView::SetData", trickData);

        if (trickData != undefined) {
            this.cardTrickData = trickData;
            // set card images
            for (let i: number = 0; i < this.imgCards.length; i++) {
                const img = this.imgCards[i];
                const cardData: CardData = this.cardTrickData.cards[i];
                img.setFrame(CardsManager.GetCardSmallFrontFrameName(cardData.suit, cardData.rank));
            }

            // set selection ring around the winner card
            this.SetSelectedCardIndex(trickData.winnerIndex);
        }

        // refresh view
        const curOrientation: ScreenOrientationType = ScreenManager.GetOrientation();
        this.UpdateViewFromOrientationChange(curOrientation);
    }

    /**
     * Use orientation-specific view
     * - uses CODED view - fixed in CODE (no 'pivot/alignment' abstraction.. too time consuming)
     * @param newOrientation 
     */
    protected override UpdateViewFromOrientationChange(newOrientation: ScreenOrientationType): void {
        // console.log(ScreenOrientationType[newOrientation]);

        // let containerPivot:ContainerPivot;
        const props = this.toggleState == ToggleState.ON ? this.bgPropsOn : this.bgPropsOff;
        switch (newOrientation) {
            // Note: LANDSCAPE orient. view has Container content ALIGNED BOTTOM-LEFT
            case ScreenOrientationType.LANDSCAPE:
                // redraw bg
                this.grBg.clear();
                // this.grBg.lineStyle(props.style.lineStyle.width, props.style.lineStyle.color, props.style.lineStyle.alpha);
                this.grBg.fillStyle(props.style.fillStyle.color, props.style.fillStyle.alpha);
                // this.grBg.strokeRoundedRect(0, -props.height, props.width, props.height, props.radius);
                this.grBg.fillRoundedRect(0, -props.height, props.width, props.height, props.radius);

                if (this.toggleState == ToggleState.OFF) {
                    this.txtLabel.setPosition(props.width * 0.5, -props.height * 0.5);

                    this.imgArrow.visible = false;
                    this.conContent.visible = false;
                }
                else
                    if (this.toggleState == ToggleState.ON) {
                        this.txtLabel.setPosition(
                            props.width * 0.5,
                            -props.height + 30 + this.txtLabel.displayHeight * 0.5);
                        this.conContent.setPosition(props.width * 0.5, -props.height * 0.5 + 80);

                        this.imgArrow.visible = true;
                        this.conContent.visible = true;
                    }

                // arrow
                this.imgArrow.setPosition(props.width - 25, this.txtLabel.y);

                // bg hitArea to make this component toggleable
                this.bgHitArea.setPosition(0, -props.height);
                this.bgHitArea.setSize(props.width, props.height);
                this.grBg.setInteractive({
                    hitArea: this.bgHitArea,
                    hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                    // draggable: false,
                    useHandCursor: true,
                });
                break;

            // Note: PORTRAIT orient. view has Container content ALIGNED TOP-LEFT
            case ScreenOrientationType.PORTRAIT:
                // redraw bg
                this.grBg.clear();
                // this.grBg.lineStyle(props.style.lineStyle.width, props.style.lineStyle.color, props.style.lineStyle.alpha);
                this.grBg.fillStyle(props.style.fillStyle.color, props.style.fillStyle.alpha);
                // this.grBg.strokeRoundedRect(0, 0, props.width, props.height, props.radius);
                this.grBg.fillRoundedRect(0, 0, props.width, props.height, props.radius);

                if (this.toggleState == ToggleState.OFF) {
                    this.txtLabel.setPosition(props.width * 0.5, props.height * 0.5);

                    this.imgArrow.visible = false;
                    this.conContent.visible = false;
                }
                else
                    if (this.toggleState == ToggleState.ON) {
                        this.txtLabel.setPosition(
                            props.width * 0.5,
                            30 + this.txtLabel.displayHeight * 0.5);
                        this.conContent.setPosition(props.width * 0.5, props.height * 0.5 + 80);

                        this.imgArrow.visible = true;
                        this.conContent.visible = true;
                    }

                // arrow
                this.imgArrow.setPosition(props.width - 25, this.txtLabel.y);

                // bg hitArea to make this component toggleable
                this.bgHitArea.setPosition(0, 0);
                this.bgHitArea.setSize(props.width, props.height);
                this.grBg.setInteractive({
                    hitArea: this.bgHitArea,
                    hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                    // draggable: false,
                    useHandCursor: true,
                });
        }
    }

    public UpdateViewFromLocalizationChange(languageId: LanguageId): void {
        this.txtLabel.text = AppLocalization.GetSharedData(languageId).table.lastTrickView.title;
    }
}